export default __webpack_public_path__ + "static/media/token_eth.bc98bd46.svg";